import {Language} from "./customEnum";
import {Chinese, English, Spanish} from "./localizedStrings";

window.GLOBAL_CONFIG = {
    isLogInPage: false,   // 当前栈顶界面是否为登录界面(包括验证界面)
    date_background: null,
    isInChattingRoom: false,
    cur_login_accountId: null,  // 当前登录账号
    cur_login_patientId: null,  // 当前登录病人id
    isLaunched: false,

    userSelectedLanguage: '',
    currentNavigator: null,
    isExplore: false,
    needUploadLanguage: false,
    needAutoOpenCovid19Page: false,
    somosUserAccessAgain:false,
    signInType: '',
    isUseNewUI: true
};

window.GLOBAL_CONFIG.userSelectedLanguage = window.userSelectedLanguage
window.GLOBAL_CONFIG.isUseNewUI = window.isUseNewUI

const languagePackage = () => {
    const {GLOBAL_CONFIG} = window
    if (GLOBAL_CONFIG && GLOBAL_CONFIG.userSelectedLanguage === Language.chinese) {
        return Chinese
    } else if (GLOBAL_CONFIG && GLOBAL_CONFIG.userSelectedLanguage === Language.spanish) {
        return Spanish
    } else {
        return English
    }
};

export {
    languagePackage
}
